import React, { useState } from 'react';
import FormAffiliationFederation from './FormAffiliationFederation';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ErrorBoundary from 'utils/ErrorBoundary';
import useFetch from 'utils/useFetch';
import Loading from 'components/Loading';

const InscriptionsFFBMP = () => {
    const { data: costBe, isLoading: loadCostBe, error: errorCostBe } = useFetch(`api/params/PriceCotisation2`);

    const value = `#### Devenez membre de la fédération
S'affilier comme marcheur individuel au sein de la Fédération Francophone Belge de Marches Populaires asbl vous donne une liberté totale pour décider où, quand et à quel rythme vous voulez marcher.
Dans la vaste gamme de randonnées, il y en a pour tous les goûts.
#### Adhésion individuelle : ${costBe} € par an
Si vous devenez membre maintenant, votre adhésion est valable jusqu'à la fin de l'année et vous donne droit à :
- La carte de membre individuelle qui vous sera envoyée par voie postale dans les plus brefs délais.
- L'assurance corporelle qui vous couvre sur toutes les marches reprises sur un calendrier officiel.
- Un abonnement au bulletin bimestriel édité par la fédération (1 par famille).
#### Rejoignez un club de marche
La F.F.B.M.P. asbl regroupe 125 clubs de marche dans toutes les provinces wallonnes et Bruxelles.
Sur le site [www.ffbmp.be](http://www.ffbmp.be/), vous trouverez peut-être un club de marche près de chez vous.
Pour participer à une marche, vous n'avez pas nécessairement besoin d'être membre d'un club de marche, mais il vous offre de nombreux autres avantages.
Les clubs de marche locaux organisent d'autres activités du club : une excursion d'une journée en bus, une fête des membres, un voyage surprise, et bien d'autres festivités ...`;
    
    const [bank, setBank] = useState("*BE73 0688 8919 2660*");

    const note = `La cotisation annuelle pour l'affiliations à la F.F.B.M.P. est de ${costBe} € à verser au compte ${bank} de la F.F.B.M.P. Affiliations, Allée des Cerisiers, 22 - 5300 NAMECHE. L'affiliation court de janvier à décembre.`;

    if (errorCostBe)
        return <p>Erreur lors du chargement des données</p>;
         
    if (loadCostBe)
        return <Loading />;

    return (<div>
        <div className="container p-4">
            <div className="row">                
                <div className="card border-1 border-primary rounded-4 bg-secondary text-primary mb-4 p-4">
                    <h1 className="text-dark">Affiliation à la FFBMP</h1>
                </div>
                <div className="p-2">
                    <ReactMarkdown children={value} remarkPlugins={[remarkGfm]} />
                </div>           
            </div>
        </div>
        <ErrorBoundary>
            <FormAffiliationFederation note={note} />
        </ErrorBoundary>
    </div>);
}

export default InscriptionsFFBMP;